export enum OpenAIModels {
  GPT_4_1 = "gpt-4.1",
  GPT_4_1_NANO = "gpt-4.1-nano",
  GPT_4 = "gpt-4",
  GPT_4O = "gpt-4o",
  GPT_4O_MINI = "gpt-4o-mini",
  GPT_4_TURBO = "gpt-4-turbo",
  GPT_3_5_TURBO = "gpt-3.5-turbo",
  O3 = "o3",
}

export enum OpenAIEmbeddingsModels {
  TEXT_EMBEDDING_ADA_002 = "text-embedding-ada-002",
  TEXT_EMBEDDING_3_SMALL = "text-embedding-3-small",
  TEXT_EMBEDDING_3_LARGE = "text-embedding-3-large",
}

export const defaultOpenAIModel = OpenAIModels.GPT_4
